let serverHost =
  process.env.NODE_ENV === 'production' ? location.origin + '/' : '/API/'

export default {
  serverHost,
  uid: sessionStorage.uid || '',
  access_token: sessionStorage.token || '',
  headpicurl: sessionStorage.headpicurl || '',
  userName: sessionStorage.userName || '',
  streetorcommunity: sessionStorage.streetorcommunity || '',
  streetorcommunityid: sessionStorage.streetorcommunityid || '',
  cityCode: '' || sessionStorage.cityCode,
  path: '',
  level: '',
  // cityLatLng: sessionStorage.cityLatLng || '',
  cityLatLng: '116.670247,39.91089',
  isAdmin: sessionStorage.isAdmin || '',
  usertypeid: sessionStorage.usertypeid || '',
  // communityDetail:sessionStorage.communityDetail || {},
  initid: sessionStorage.initid || '',
  navIndex: sessionStorage.navIndex || 0,
  sideList: '[]',
  GZHhead: sessionStorage.GZHhead || '',
  GZHname: sessionStorage.GZHname || '',
  systemName: '党建引领，基层治理平台',
  filterList: [], // 右侧过滤器组件
  labelList: [], // 过滤器的label显示
  spinShow: false, // 加载中显示
  miniCommunityChangeId: sessionStorage.miniCommunityChangeId || sessionStorage.streetorcommunityid || '', // 微社区行政区域id
  sideIndex: sessionStorage.sideIndex || 0,
  childrenInd: sessionStorage.childrenInd || 0,
  navText: sessionStorage.navText || '',
  isTV: sessionStorage.isTV || 0,
  enrollment: sessionStorage.enrollment || 0,
  isJiedao: sessionStorage.isJiedao || 0,
  navigatorList: sessionStorage.navigatorList || '[]',
  allowBack: true || sessionStorage.allowBack,
  location: sessionStorage.location || '',
  swiperTv:-1,
  shequSideBar:sessionStorage.shequSideBar || '[]',
  apptype:sessionStorage.apptype || 'mst',
  managerList: [],
  xiaofeiquanVue : {}, //消费券主页 Xiaofeiquan/index.vue
  userWorker:0, //是否为管理员
}
